<template>
	<v-dialog
		persistent
		max-width="600"
		v-model="dialog"
	>
		<v-card v-if="e">
			<v-card-title>
				<span>Atlaso puslapio šablonas</span>
			</v-card-title>
			<v-card-text>
				<v-item-group
					v-model="templateNumber"
					active-class="active-item"
				>
					<template v-for="(group, i) in items">
						<div class="mt-2" :key="'group-' + i">{{i + 1}}. {{group.title}}</div>
						<template v-for="(item, j) in group.items">
							<PageTemplateButton :id="item" :key="'item-' + i + '-' + j" />
						</template>
					</template>
				</v-item-group>
			</v-card-text>
			<v-card-actions class="mx-4 pb-5">
				<v-btn
					color="blue darken-1"
					text
					v-on:click="save"
					outlined
					small
					:loading="saveInAction"
					:disabled="templateNumber == null"
				>
					Išsaugoti
				</v-btn>
				<v-btn
					color="blue darken-1"
					text
					v-on:click="closeDialog"
					outlined
					small
					:disabled="saveInAction"
				>
					Atšaukti
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	import PageTemplateButton from "./PageTemplateButton";

	export default {
		data: function(){
			var data = {
				dialog: false,
				saveInAction: false,
				e: null,
				templateNumber: null,
				items: [{
					title: "Kurti žemėlapį/turinį tuščiame puslapyje",
					items: ["1x1"]
				},{
					title: "Kurti kompleksinį turinį gardelėje",
					items: ["1x2", "1x3", "2x1", "2x2", "2x3", "3x1", "3x2", "3x3"]
				},{
					title: "Kurti objektų sekos žemėlapį",
					items: ["objects"]
				}]
			};
			return data;
		},
		components: {
			PageTemplateButton
		},
		created: function(){
			this.iteration = 0;
			this.$vBus.$on("show-page-template-selector", this.showPageTemplateSelector);
		},
		beforeDestroy: function(){
			this.$vBus.$off("show-page-template-selector", this.showPageTemplateSelector);
		},
		methods: {
			closeDialog: function(){
				this.e = null;
				this.dialog = false;
			},
			save: function(){
				if (this.e.callback) {
					this.saveInAction = true;
					var callback = function(status){
						if (status) {
							this.closeDialog();
						} else {
							this.saveInAction = false;
						}
					}.bind(this);
					var templateId = null,
						i = 0;
					this.items.forEach(function(group){
						group.items.some(function(item){
							if (i == this.templateNumber) {
								templateId = item;
							}
							i += 1;
						}.bind(this));
						if (templateId) {
							return true;
						}
					}.bind(this));
					this.e.callback(templateId, callback);
				}
			},
			getKey: function(field){
				var key = field.key + "-" + this.iteration;
				return key;
			},
			showPageTemplateSelector: function(e){
				this.iteration += 1;
				this.e = e;
				this.templateNumber = null;
				this.saveInAction = false;
				this.dialog = true;
			}
		}
	}
</script>